"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamilyAlternate = exports.fontFamily = void 0;
const react_native_1 = require("react-native");
exports.fontFamily = react_native_1.Platform.OS === 'web' ? 'Roboto' : undefined;
exports.fontFamilyAlternate = react_native_1.Platform.OS === 'web' ? 'Ubuntu' : undefined;
